module.exports = __webpack_public_path__ + "static/7 - Raptor 4-1cfbc5b1d9cbf0e6dfbcc76e545026aa.jpg";